import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  ID1z61wlmtvxrjn as ID,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  CareLocationClosure1da03s5ze3kft as CareLocationClosure,
  ChildAttendance80k6ssgtlom9 as ChildAttendance,
  IDknm0szoty74n as ID_0,
  Family2k7vz7ddyergb as Family,
  IDjecfjjw6mot9 as ID_1,
  CareLocation1v3u5wduz023s as CareLocation,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  ClosedLocalDateRange6599xgap66zd as ClosedLocalDateRange,
  LocalDateRangefowoyqa24icz as LocalDateRange,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_location1p3um6ao7ento as get_location,
  get_activeRangedsifhrs4gcfc as get_activeRange,
  get_location5qvftw9oaw3d as get_location_0,
  get_date13hdmf8teioql as get_date,
  get_location22dxferxpyzkz as get_location_1,
  get_date4gxx2ixf9cue as get_date_0,
  get__id2ft65q2wfav1v as get__id,
  get__id336i6k806byxy as get__id_0,
  get__id2p9nbcwbj0zlw as get__id_1,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  overlaps2e3dna24gi3hb as overlaps,
  insideoec66sredh4u as inside,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dateRangeConditions.mjs';
import { and3dbt2f202um49 as and } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
  ID3lnbkn76l7dgd as ID_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import {
  compareBy2697bq0ffft96 as compareBy,
  compareValues1n2ayl87ihzfk as compareValues,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Companion_getInstance1ts49hpe5lvz6 as Companion_getInstance } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import { getValue$ref3cl0ea1sg24pj as getValue$ref } from './attendanceGrid.mjs';
import { get_yearMonth3uo9i62rhbu6p as get_yearMonth } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { sequenceOfdrc6uefhtiet as sequenceOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { plus2l6bq32n2wlna as plus_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { appendCsvRows26y51byhnrjfx as appendCsvRows } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvConfig.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *attendanceSheetCsv(api, periods, blank, $completion) {
  if (periods.isEmpty_y1axqb_k$())
    return '';
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(periods, 10));
  var _iterator__ex2g4s = periods.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$2 = new (ID())(item.location_1);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  var locationIds = toSet(destination);
  // Inline function 'kotlin.collections.minOf' call
  var iterator = periods.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
  var minValue = iterator.next_20eer_k$().period_1.start_1;
  while (iterator.hasNext_bitz1p_k$()) {
    var v = iterator.next_20eer_k$().period_1.start_1;
    if (compareTo(minValue, v) > 0) {
      minValue = v;
    }
  }
  var tmp = minValue;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_0 = periods.iterator_jk1svi_k$();
  if (!iterator_0.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
  var maxValue = iterator_0.next_20eer_k$().period_1.endInclusive_1;
  while (iterator_0.hasNext_bitz1p_k$()) {
    var v_0 = iterator_0.next_20eer_k$().period_1.endInclusive_1;
    if (compareTo(maxValue, v_0) < 0) {
      maxValue = v_0;
    }
  }
  var tmp$ret$6 = maxValue;
  var overall = new (ClosedLocalDateRange())(tmp, tmp$ret$6);
  var tmp_0 = api.get_childPlacement_o77pq_k$();
  var tmp2 = 2147483647;
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$12);
  var tmp$ret$13 = and(xDataClassPathInsideSet(get_location(it), locationIds), overlaps(get_activeRange(it), overall));
  var tmp$ret$9 = new (Query())(tmp$ret$13, orderBy, 0, tmp2);
  var placements = yield* tmp_0.query_o986pg_k$(tmp$ret$9, $completion);
  var tmp_2 = api.get_careLocationClosure_wog2z0_k$();
  var tmp2_0 = 2147483647;
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy_0 = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(CareLocationClosure()), arrayOf([]), false));
  var tmp$ret$17 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$17);
  var tmp$ret$18 = and(xDataClassPathInsideSet(get_location_0(it_0), locationIds), inside(get_date(it_0), overall));
  var tmp$ret$14 = new (Query())(tmp$ret$18, orderBy_0, 0, tmp2_0);
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = yield* tmp_2.query_o986pg_k$(tmp$ret$14, $completion);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
  var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s_0.next_20eer_k$();
    var tmp$ret$21 = to(new (ID())(element.location_1), element.date_1);
    destination_0.put_4fpzoq_k$(tmp$ret$21, element);
  }
  var closures = destination_0;
  var tmp_4;
  if (blank) {
    // Inline function 'kotlin.collections.mapOf' call
    tmp_4 = emptyMap();
  } else {
    var tmp_5 = api.get_childAttendance_eqcv24_k$();
    var tmp2_1 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy_1 = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_6 = serializerOrContextual(createKType(getKClass(ChildAttendance()), arrayOf([]), false));
    var tmp$ret$26 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
    var it_1 = new (DataClassPathSelf())(tmp$ret$26);
    var tmp$ret$27 = and(xDataClassPathInsideSet(get_location_1(it_1), locationIds), inside(get_date_0(it_1), overall));
    var tmp$ret$23 = new (Query())(tmp$ret$27, orderBy_1, 0, tmp2_1);
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = yield* tmp_5.query_o986pg_k$(tmp$ret$23, $completion);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
    var _iterator__ex2g4s_1 = this_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
      var tmp$ret$30 = to(new (ID_0())(element_0.placement_1), element_0.date_1);
      destination_1.put_4fpzoq_k$(tmp$ret$30, element_0);
    }
    tmp_4 = destination_1;
  }
  var attendance = tmp_4;
  var tmp_7 = api.get_careLocationPrograms_g0oima_k$();
  var tmp2_2 = 2147483647;
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy_2 = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_8 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
  var tmp$ret$34 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$34);
  var tmp_9 = get__id(it_2);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_2 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_2 = placements.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
    var element_1 = _iterator__ex2g4s_2.next_20eer_k$();
    var list = element_1.schedule_1.get_programs_mo5naw_k$();
    addAll(destination_2, list);
  }
  var tmp$ret$35 = xDataClassPathInsideSet(tmp_9, toSet(destination_2));
  var tmp$ret$31 = new (Query())(tmp$ret$35, orderBy_2, 0, tmp2_2);
  // Inline function 'kotlin.collections.associateBy' call
  var this_2 = yield* tmp_7.query_o986pg_k$(tmp$ret$31, $completion);
  var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_3 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_1);
  var _iterator__ex2g4s_3 = this_2.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
    var element_2 = _iterator__ex2g4s_3.next_20eer_k$();
    var tmp$ret$41 = new (ID_2())(element_2._id_1);
    destination_3.put_4fpzoq_k$(tmp$ret$41, element_2);
  }
  var programs = destination_3;
  var tmp_10 = api.get_family_d7lffx_k$();
  var tmp2_3 = 2147483647;
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy_3 = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$45 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$45);
  var tmp_12 = get__id_0(it_3);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(placements, 10));
  var _iterator__ex2g4s_4 = placements.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
    var item_0 = _iterator__ex2g4s_4.next_20eer_k$();
    var tmp$ret$49 = new (ID_1())(item_0.family_1);
    destination_4.add_utx5q5_k$(tmp$ret$49);
  }
  var tmp$ret$46 = xDataClassPathInsideSet(tmp_12, toSet(destination_4));
  var tmp$ret$42 = new (Query())(tmp$ret$46, orderBy_3, 0, tmp2_3);
  // Inline function 'kotlin.collections.associateBy' call
  var this_3 = yield* tmp_10.query_o986pg_k$(tmp$ret$42, $completion);
  var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_3, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_5 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_2);
  var _iterator__ex2g4s_5 = this_3.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
    var element_3 = _iterator__ex2g4s_5.next_20eer_k$();
    var tmp$ret$52 = new (ID_1())(element_3._id_1);
    destination_5.put_4fpzoq_k$(tmp$ret$52, element_3);
  }
  var families = destination_5;
  var tmp_13 = api.get_careLocation_drerzj_k$();
  var tmp2_4 = 2147483647;
  // Inline function 'com.lightningkite.services.database.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy_4 = emptyList();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_14 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$56 = isInterface(tmp_14, KSerializer()) ? tmp_14 : THROW_CCE();
  var it_4 = new (DataClassPathSelf())(tmp$ret$56);
  var tmp$ret$57 = xDataClassPathInsideSet(get__id_1(it_4), locationIds);
  var tmp$ret$53 = new (Query())(tmp$ret$57, orderBy_4, 0, tmp2_4);
  // Inline function 'kotlin.collections.associateBy' call
  var this_4 = yield* tmp_13.query_o986pg_k$(tmp$ret$53, $completion);
  var capacity_3 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_4, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_6 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_3);
  var _iterator__ex2g4s_6 = this_4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
    var element_4 = _iterator__ex2g4s_6.next_20eer_k$();
    var tmp$ret$60 = new (ID())(element_4._id_1);
    destination_6.put_4fpzoq_k$(tmp$ret$60, element_4);
  }
  var locations = destination_6;
  var tmp_15 = listOf(['Provider', 'Location', 'Service month', 'Child', 'FID', 'DOB', 'Placement start', 'Placement end', 'Program', 'Transport']);
  // Inline function 'kotlin.collections.map' call
  var this_5 = numberRangeToNumber(1, 31);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_7 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_5, 10));
  var inductionVariable = this_5.first_1;
  var last = this_5.last_1;
  if (inductionVariable <= last)
    do {
      var item_1 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$63 = item_1.toString();
      destination_7.add_utx5q5_k$(tmp$ret$63);
    }
     while (!(item_1 === last));
  var header = plus(tmp_15, destination_7);
  var tmp_16 = (it) => getValue(locations, new (ID())(it.location_1)).name_1;
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = sortedWith(periods, compareBy([tmp_16, attendanceSheetCsv$lambda]));
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_8 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_7 = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_7.hasNext_bitz1p_k$()) {
    var element_5 = _iterator__ex2g4s_7.next_20eer_k$();
    var location = getValue(locations, new (ID())(element_5.location_1));
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_9 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_8 = placements.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_8.hasNext_bitz1p_k$()) {
      var element_6 = _iterator__ex2g4s_8.next_20eer_k$();
      if (equals(element_6.location_1, element_5.location_1) && element_6.activeRange_1.overlaps_cm89fs_k$(new (LocalDateRange())(element_5.period_1.start_1, element_5.period_1.endInclusive_1))) {
        destination_9.add_utx5q5_k$(element_6);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_17 = attendanceSheetCsv$lambda_0;
    var tmp$ret$71 = new (sam$kotlin_Comparator$0())(tmp_17);
    // Inline function 'kotlin.collections.map' call
    var this_6 = sortedWith(destination_9, tmp$ret$71);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_10 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_6, 10));
    var _iterator__ex2g4s_9 = this_6.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_9.hasNext_bitz1p_k$()) {
      var item_2 = _iterator__ex2g4s_9.next_20eer_k$();
      var days = filterNotNull(item_2.schedule_1.get_all_18j9hk_k$());
      // Inline function 'kotlin.takeIf' call
      var tmp_18;
      var tmp$ret$77;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_19;
        if (isInterface(days, Collection())) {
          tmp_19 = days.isEmpty_y1axqb_k$();
        } else {
          tmp_19 = false;
        }
        if (tmp_19) {
          tmp$ret$77 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_10 = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_10.hasNext_bitz1p_k$()) {
          var element_7 = _iterator__ex2g4s_10.next_20eer_k$();
          if (element_7.transportTo_1) {
            tmp$ret$77 = true;
            break $l$block_0;
          }
        }
        tmp$ret$77 = false;
      }
      if (tmp$ret$77) {
        tmp_18 = 'To';
      } else {
        tmp_18 = null;
      }
      var tmp_20 = tmp_18;
      // Inline function 'kotlin.takeIf' call
      var tmp_21;
      var tmp$ret$81;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_22;
        if (isInterface(days, Collection())) {
          tmp_22 = days.isEmpty_y1axqb_k$();
        } else {
          tmp_22 = false;
        }
        if (tmp_22) {
          tmp$ret$81 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_11 = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_11.hasNext_bitz1p_k$()) {
          var element_8 = _iterator__ex2g4s_11.next_20eer_k$();
          if (element_8.transportFrom_1) {
            tmp$ret$81 = true;
            break $l$block_2;
          }
        }
        tmp$ret$81 = false;
      }
      if (tmp$ret$81) {
        tmp_21 = 'From';
      } else {
        tmp_21 = null;
      }
      var tmp$ret$79 = tmp_21;
      var transport = joinToString(listOfNotNull([tmp_20, tmp$ret$79]), '/');
      // Inline function 'kotlin.collections.map' call
      var this_7 = numberRangeToNumber(1, 31);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_11 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_7, 10));
      var inductionVariable_0 = this_7.first_1;
      var last_0 = this_7.last_1;
      if (inductionVariable_0 <= last_0)
        do {
          var item_3 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp0_0 = item_3;
          var tmp$ret$85;
          $l$block_5: {
            var tmp0_1 = element_5.period_1;
            var tmp$ret$86;
            $l$block_3: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_12 = tmp0_1.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_12.hasNext_bitz1p_k$()) {
                var element_9 = _iterator__ex2g4s_12.next_20eer_k$();
                if (element_9.day_1 === tmp0_0) {
                  tmp$ret$86 = element_9;
                  break $l$block_3;
                }
              }
              tmp$ret$86 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$86;
            var tmp_23;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$85 = '';
              break $l$block_5;
            } else {
              tmp_23 = tmp0_elvis_lhs;
            }
            var date = tmp_23;
            var tmp_24 = Companion_getInstance();
            var tmp1_safe_receiver = closures.get_wei43m_k$(to(new (ID())(element_5.location_1), date));
            var tmp_25 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.reason_1;
            var tmp2_elvis_lhs = tmp_24.of_tn5enx_k$(item_2, date, tmp_25, getValue$ref(programs));
            var tmp_26;
            if (tmp2_elvis_lhs == null) {
              tmp$ret$85 = '';
              break $l$block_5;
            } else {
              tmp_26 = tmp2_elvis_lhs;
            }
            var expected = tmp_26;
            var tmp_27;
            if (blank && !(expected.closure_1 == null)) {
              tmp_27 = 'Closed';
            } else if (blank) {
              tmp_27 = expected.scheduled_1.time_1.code_1;
            } else {
              var tmp3_safe_receiver = attendance.get_wei43m_k$(to(new (ID_0())(item_2._id_1), date));
              var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.attendance_1;
              var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.get_massachusettsAttendanceCode_3eo4hh_k$();
              var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.get_code_wok7xy_k$();
              tmp_27 = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
            }
            tmp$ret$85 = tmp_27;
          }
          destination_11.add_utx5q5_k$(tmp$ret$85);
        }
         while (!(item_3 === last_0));
      var dayCells = destination_11;
      var tmp_28 = get_yearMonth(element_5.period_1.start_1).toString();
      var tmp_29 = toString(getValue(families, new (ID_1())(item_2.family_1)).shortId_1);
      var tmp_30 = item_2.childBirthDate_1.toString();
      var tmp_31 = item_2.activeRange_1.start_1.toString();
      var tmp0_safe_receiver = item_2.activeRange_1.endInclusive_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
      var tmp_32 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_2 = item_2.schedule_1.get_all_18j9hk_k$();
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_12 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_13 = tmp0_2.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_13.hasNext_bitz1p_k$()) {
        var element_10 = _iterator__ex2g4s_13.next_20eer_k$();
        var tmp_33 = element_10 == null ? null : element_10.program_1;
        var tmp0_safe_receiver_0 = tmp_33 == null ? null : new (ID_2())(tmp_33);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_12.add_utx5q5_k$(tmp0_safe_receiver_0);
        }
      }
      var tmp_34 = toSet(destination_12);
      var tmp$ret$74 = plus(listOf([location.providerName_1, location.name_1, tmp_28, item_2.childName_1, tmp_29, tmp_30, tmp_31, tmp_32, joinToString(tmp_34, '; ', VOID, VOID, VOID, VOID, (it) => getValue(programs, it).name_1), transport]), dayCells);
      destination_10.add_utx5q5_k$(tmp$ret$74);
    }
    var list_0 = destination_10;
    addAll(destination_8, list_0);
  }
  var rows = destination_8;
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_8 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  appendCsvRows(this_8, plus_0(sequenceOf(header), asSequence(rows)));
  return this_8.toString();
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function attendanceSheetCsv$lambda(it) {
  return it.period_1.start_1;
}
function attendanceSheetCsv$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.childName_1;
  var tmp$ret$2 = b.childName_1;
  return compareValues(tmp, tmp$ret$2);
}
//region block: exports
export {
  attendanceSheetCsv as attendanceSheetCsv15opd55ow0c0p,
};
//endregion

//# sourceMappingURL=attendanceSheet.mjs.map
